import { Alert, Stack, Typography } from "@mui/material"
import type { BulkVersionRow } from "../../hooks/useBulkVersionChange"
import { FeatureErrors } from "../common/featureErrors"

/** The captured revision belongs to THIS publication attempt, never a placement. */
export function BulkVersionResults({ row }: { row: BulkVersionRow }) {
  return (
    <Stack spacing={1}>
      {row.capturedRevision !== undefined && (
        <Typography>Отправленная ревизия: {row.capturedRevision}</Typography>
      )}
      {row.attempt && (
        <Typography>
          Запрошенная версия: {row.attempt.templateVersionId}
        </Typography>
      )}
      {row.outcome === "success" && (
        <Alert severity="success">
          {row.reconciled
            ? `Желаемые изменения уже применены — проверено GET, ревизия ${row.remote?.revision}. Повтор не нужен.`
            : `Успешно — ревизия ${row.result?.ok ? row.result.revision : ""}`}
        </Alert>
      )}
      {row.outcome === "failed" && (
        <Alert severity="error">
          Не применено. Перед повтором обновите публикацию и подтвердите
          предложение.
        </Alert>
      )}
      {row.result && !row.result.ok && (
        <>
          <Typography>
            HTTP {row.result.error.status} · {row.result.error.code}
          </Typography>
          <FeatureErrors error={row.result.error} />
        </>
      )}
      {row.outcome === "unknown" && (
        <Alert severity="warning">
          Результат неизвестен: изменения могли примениться. Не повторяйте
          запрос без GET-проверки.
        </Alert>
      )}
      <FeatureErrors error={row.error} />
      {row.remote && row.outcome !== "success" && (
        <>
          <Typography variant="h6">Сравнение перед повтором</Typography>
          <Typography>
            Сравните версию и значения. Непереданные значения сохраняются;
            предложение заменяет только изменённые UUID целиком. Исправьте
            предложение ниже или подтвердите его явно.
          </Typography>
          <Snapshot
            label="До отправки"
            versionId={row.attemptBaseline?.templateVersionId}
            revision={row.attemptBaseline?.revision}
            bindings={row.attemptBaseline?.bindings}
          />
          <Snapshot
            label="Свежая публикация"
            versionId={row.remote.templateVersionId}
            revision={row.remote.revision}
            bindings={row.remote.bindings}
          />
          <Snapshot
            label="Предложение"
            versionId={row.templateVersionId}
            bindings={row.bindings}
          />
          {row.reviewed && (
            <Alert severity="info">
              Предложение подтверждено. Повтор — отдельное действие.
            </Alert>
          )}
        </>
      )}
    </Stack>
  )
}

function Snapshot({
  label,
  versionId,
  revision,
  bindings,
}: {
  label: string
  versionId?: string
  revision?: number
  bindings?: BulkVersionRow["bindings"]
}) {
  return (
    <Stack>
      <Typography>
        {label}: версия {versionId}
        {revision !== undefined ? `, ревизия ${revision}` : ""}
      </Typography>
      <Typography
        component="pre"
        sx={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}
      >
        {JSON.stringify(bindings, null, 2)}
      </Typography>
    </Stack>
  )
}
